<template><div class="unit-map">
  <div>
    <button @click="openTimeWindowDialog" v-html="timeWindowSummary" />
    <transition name="fetch" appear><loading v-if="fetching" /></transition>
    <ModalDialog v-if="newTimeWindow" @close="newTimeWindow = null">
      <div v-if="newTimeWindow.type === 'last'">
        <div class="type">Show location since ...</div>
        <div class="detail">
          <select v-model="newTimeWindow.seconds">
            <option disabled></option>
            <option v-for="s in lastOptions" :key="'twlso-'+s"
              :value="s" v-html="relativeTime(s)" />
          </select>
          <button @click="acceptNewTimeWindow">OK</button>
        </div>
        <div class="options">
          Or...
          <a @click="ntwt('date')" key="selDate">&gt; <span>Show calendar date ...</span></a>
          <a @click="ntwt('range')" key="selRange">&gt; <span>Show date/time range ...</span></a>
        </div>
      </div>
      <div v-else-if="newTimeWindow.type === 'date'">
        <div class="type">Show calendar day ...</div>
        <div class="detail">
          <date-select v-model="newTimeWindow.start" /> 
          <button @click="acceptNewTimeWindow">OK</button>
          <button @click="showToday">Today</button>
        </div>
        <div class="options">
          Or...
          <a @click="ntwt('range')" key="selRange">&gt; <span>Show date/time range ...</span></a>
          <a @click="ntwt('last')" key="selLast">&gt; <span>Show location since ...</span></a>
        </div>
      </div>
      <div v-else-if="newTimeWindow.type === 'range'">
        <div class="type">Show date/time range ...</div>
        <div class="detail">
          From:
          <date-select v-model="newTimeWindow.start" :max="newTimeWindow.end" />
          <time-select v-model="newTimeWindow.start" :max="newTimeWindow.end" />
          To:
          <date-select v-model="newTimeWindow.end" :min="newTimeWindow.start" />
          <time-select v-model="newTimeWindow.end" :min="newTimeWindow.start" />
          <button @click="acceptNewTimeWindow">OK</button>
        </div>
        <div class="options">
          Or...
          <a @click="ntwt('last')" key="selLast">&gt; <span>Show location since ...</span></a>
          <a @click="ntwt('date')" key="selDate">&gt; <span>Show calendar date ...</span></a>
        </div>
      </div>
    </ModalDialog>
  </div>
  <g-map :unitId="nowIsWithinTimeBounds ? id : null" :tracklog="tracklog" />
</div></template>
<script>

import moment from 'moment'

import api from '../api'
import DateSelect from './DateSelect'
import GMap from './GMap'
import { Google } from './GMap'
import Loading from './Loading'
import ModalDialog from './ModalDialog'
import TimeSelect from './TimeSelect'

global.moment = moment

let google = null

export default {
  name: 'unit-map',
  components: { DateSelect, Loading, ModalDialog, GMap, TimeSelect },
  created() {
    global.unitMap = this
  },
  async mounted() {
    google = await Google
    this.fetchTracklog(true)
  },
  computed: {
    id() { return this.$store.state.selectedUnit },
    unit() { return this.$store.state.units[this.id] },
    timeWindowSummary() {
      switch (this.timeWindow.type) {
      case 'last':
        return `Showing location since ${this.relativeTime(this.timeWindow.seconds)}...`
      case 'date':
        return `Showing ${this.timeWindow.start.format('YYYY-MMM-DD')}...`
      case 'range':
        return `Showing selected time range...`
      default:
        return 'time window error!'
      }
    },
    nowIsWithinTimeBounds() {
      let w = this.getTimeBounds()
      return !(
        !this.unit
        || !moment.isMoment(this.unit.lastFetched)
        || this.unit.lastFetched.isBefore(w[0])
        || this.unit.lastFetched.isAfter(w[1])
      )
    },
  },
  data() {
    return {
      newTimeWindow: null,
      google: null,
      tracklog: null,
      refetchComplete: null,
      fetching: false,
      timeWindow: { type: 'last', seconds: 3600 },
      lastOptions: [ 60, 600, 1800, 3600, 7200, 14400, 28800, 86400, 172800, 345600, 604800 ],
    }
  },
  watch: {
    'newTimeWindow.seconds': function(nv,ov) {
      if (!ov || !nv) return // ignore show/hide time window ui
      this.acceptNewTimeWindow()
    },
    'newTimeWindow.start': function(nv,ov) {
      let ntw = this.newTimeWindow
      if (!ntw || ntw.type !== 'date') return
      ntw.end = nv.clone().endOf('day')
    },
    id() {
      this.fetchTracklog(true)
    },
    'unit.lastFetched': function(nv, ov) {
      if (moment.isMoment(nv) && moment.isMoment(ov) && nv.diff(ov, 'minutes') > 10) {
        // Do a complete reload if more than 10 minutes have passed.
        this.fetchTracklog(true)
      } else {
        // Otherwise, do a partial reload.
        this.fetchTracklog(false)
      }
    },
  },
  methods: {
    openTimeWindowDialog() {
      this.newTimeWindow = Object.assign({}, this.timeWindow)
    },
    ntwt(nt) {
      let ntw = this.newTimeWindow
      switch (nt) {
      case 'date':
      case 'range':
        if ('start' in ntw) {
          this.newTimeWindow = {
            type: nt,
            start: ntw.start.clone().startOf('day'),
            end: ntw.start.clone().endOf('day'),
          }
        } else {
          let now = moment()
          this.newTimeWindow = {
            type: nt,
            start: now.startOf('day'),
            end: now.clone().endOf('day'),
          }
        }
        break
      case 'last':
        this.newTimeWindow = {
          type: 'last',
          seconds: 3600,
        }
        break
      }
    },
    acceptNewTimeWindow() {
      if (JSON.stringify(this.timeWindow) !== JSON.stringify(this.newTimeWindow)) {
        this.timeWindow = this.newTimeWindow
        this.fetchTracklog(true)
      }
      this.newTimeWindow = null
    },
    relativeTime(seconds) {
      let t1 = moment(),
        t2 = t1.clone().add(seconds, 'seconds')
      return t1.from(t2)
    },
    showToday() {
      this.newTimeWindow.start = moment().startOf('day')
    },
    getTimeBounds() {
      switch (this.timeWindow.type) {
      case 'last':
        let now = moment()
        return [now.clone().subtract(this.timeWindow.seconds, 'seconds'), now]
      case 'date':
      case 'range':
        return [this.timeWindow.start.clone(), this.timeWindow.end.clone()]
      }
      return [moment(),moment()]
    },
    async fetchTracklog(complete) {
      if (!google) return
      if (this.fetching) {
        if (complete || !this.refetchComplete)
          this.refetchComplete = complete
        return
      }
      this.fetching = true
      this.refetchComplete = null
      try {
        let w = this.getTimeBounds(),
          incremental = !complete && this.tracklog && this.tracklog.length,
          start = incremental ? moment.unix(this.tracklog.getAt(this.tracklog.length-1)[0]) : w[0]
        if (!incremental) {
          this.tracklog = null
        }
        let rv = (
          this.id
            ? await api.unitTracklog({
              uid: this.id,
              start: start,
              end: w[1],
            })
            : { tracklog: [] }
        )
        if (incremental) {
          for (let coord of rv.tracklog) {
            this.tracklog.push(coord)
            if (this.tracklog.length > 20000)
              this.tracklog.removeAt(0)
          }
          while (this.tracklog.getAt(0)[0] < w[0].unix())
            this.tracklog.removeAt(0)
        } else {
          this.tracklog = new google.maps.MVCArray(rv.tracklog)
          global.tracklog = this.tracklog
        }
      } finally {
        this.fetching = false
        if (this.refetchComplete !== null)
          this.fetchTracklog(this.refetchComplete)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .unit-map {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    background: #bbb;
    > :first-child {
      padding: 5px 5px 0 10px;
      button { background: #ddd; margin: 0 5px 5px 0; &:hover { background: #eee; } }
    }
    .loading {
      width: 18px;
      height: 18px;
    }
    .fetch-enter { opacity: 0; }
    .fetch-enter-to { transition: all 1s; }
    .fetch-leave-to { opacity: 0; transition: all .25s; }
    .modal-dialog {
      .detail {
        margin: 10px 20px;
      }
      .options {
        margin-bottom: -5px;
        a {
          display: block;
          cursor: pointer;
          padding: 10px 0 5px 0;
          > * { text-decoration: underline; }
          &:hover {
            > * { text-decoration: none; }
          }
        }
      }
    }
  }
</style>
